/**
*
*   Content Block
*       - A left/right content block + image or video
*
**/
'use client';

import Image from '@/components/image';
//import { gsap } from 'gsap';
//import { useGSAP } from "@gsap/react";
//import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
import { useState, useRef } from 'react';
import { useLocale } from 'next-intl';

//Load Module
//gsap.registerPlugin(useGSAP);
//gsap.registerPlugin(ScrollTrigger);

//Build the Element
export default function Quote({ product , grid = true , ...props }){

	const ref = useRef();

	const [ open , setOpen ] = useState( false );

	const locale = useLocale();
/*
	//On Mount
	useGSAP(() => {

		//Skip if it hasn't loaded, or we're not in grid format
		if( !ref.current || !grid ) return;

		//Prepare the MatchMedia
		let mm = gsap.matchMedia();

		//Set Variables
		const $section  = ref.current;
		const $intro    = $section.querySelector('#intro');
		const $title    = $intro.querySelectorAll('h2 > *');
		const $image    = $intro.querySelector('img');
		const $content  = $section.querySelectorAll('.content');
		const $safety   = $section.querySelector('#safety');

		//
		mm.add('(min-width: 751px)', context => {

			//Create Timeline
			let timeline = gsap.timeline({
				scrollTrigger: {
					trigger:                $section,
					invalidateOnRefresh:    true,
					scrub:                  true,
					pin:                    false,
					markers:                false,
					start:                  '-70% left',
					end:                    '-25% left',
				},
			});

			//Title
			$title.forEach(
				( $part, i ) => timeline.fromTo( $part, { opacity:0, yPercent:25 },{ opacity:1, yPercent:0 })
			)

			timeline.fromTo( $image, { opacity:0, scale:0.95 },{ opacity:1, scale:1 });

			//Image Animation
			//timeline.fromTo( [ $content, $safety ], { opacity:0, yPercent:15 },{ opacity:1, yPercent:0 });

		});

		//
		mm.add('(max-width: 750px)', context => {

			//Create Timeline
			let timeline = gsap.timeline({
				scrollTrigger: {
					trigger:                $section,
					invalidateOnRefresh:    true,
					scrub:                  true,
					pin:                    false,
					markers:                false,
					once:                   true,
					start:                  '-70% left',
					end:                    '0 left',
				},
			});

			//Title
			$title.forEach(
				( $part, i ) => timeline.fromTo( $part, { opacity:0, yPercent:15 },{ opacity:1, yPercent:0 })
			);

			timeline.fromTo( $image, { opacity:0, scale:0.1, yPercent:15 },{ opacity:1, scale:1, yPercent:0 });

			//Image Animation
			timeline.fromTo( [ $content, $safety ], { opacity:0, yPercent:15 },{ opacity:1, yPercent:0 });

		});

	}, { scope: ref.current });
*/
	//In Grid
	if(grid) return (
		<div id="usage" ref={ ref } className="grid auto container">
			<div className="col">
				<div className="content" dangerouslySetInnerHTML={{
					__html: product.box.content?.[ locale ]
				}} />
				{ product.box.safety?.[ locale ] != '' && (
					<dl id="safety" className={ open ? 'open' : '' }>
						<dt>
							<a onClick={ () => setOpen(!open) }>
								<h2>Safety Recommendations</h2>
								<span>
									<span></span>
									<span></span>
								</span>
							</a>
						</dt>
						<dd className="content">
							<p>{ product.box.safety?.[ locale ] }</p>
						</dd>
					</dl>
				)}
			</div>
			<div className="col">
				{ /* Empty */ }
			</div>
			<div className="col">
				<div id="intro">
					<header>
						<h2 dangerouslySetInnerHTML={{
							__html: product.box.headline?.[ locale ]
						}} />
						<Image src={ product.box.photo.src } alt="" width="405" height="300" />
					</header>
				</div>
			</div>
		</div>
	);



	//Full Width
	return (
		<div id="usage" ref={ ref }>
			<section id="intro" className="full">
				<header>
					<h2 dangerouslySetInnerHTML={{
						__html: product.box.headline?.[ locale ]
					}} />
				</header>
				<div>
					<Image src={ product.box.photo.src } alt="" width="405" height="300" />
					<div className="content">
						<div dangerouslySetInnerHTML={{
							__html: product.box.content?.[ locale ]
						}} />
						{ product.box.safety?.[ locale ] != '' && (
							<dl id="safety" className={ open ? 'open' : '' }>
								<dt>
									<a onClick={ () => setOpen(!open) }>
										<h2>Safety Recommendations</h2>
										<span>
											<span></span>
											<span></span>
										</span>
									</a>
								</dt>
								<dd className="content">
									<p>{ product.box.safety?.[ locale ] }</p>
								</dd>
							</dl>
						)}
					</div>
				</div>
			</section>

		</div>
	);

}